import { render, staticRenderFns } from "./SiteAppsPluginSettingsDrawer.vue?vue&type=template&id=68400e8e&scoped=true&"
import script from "./SiteAppsPluginSettingsDrawer.vue?vue&type=script&lang=js&"
export * from "./SiteAppsPluginSettingsDrawer.vue?vue&type=script&lang=js&"
import style0 from "./SiteAppsPluginSettingsDrawer.vue?vue&type=style&index=0&id=68400e8e&prod&scoped=true&lang=scss&"
import style1 from "./SiteAppsPluginSettingsDrawer.vue?vue&type=style&index=1&id=68400e8e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68400e8e",
  null
  
)

export default component.exports